import CurrencyInput from "Components/CurrencyInput";
import { useFormik } from "formik";
import {
  adminUpdateBenefitById,
  adminUpdateDeductionById,
  adminUpdateSalaryById,
} from "helpers/backend_helpers";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { toast } from "react-toastify";
import {
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import * as Yup from "yup";

const UpdateModalDeduction = ({ show, onCloseClick, getData, data }: any) => {
  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: data.name || "",
      amount: data.amount || 0,
      description: data.description || "",
      isActive: data.isActive || false,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Nama harus diisi!"),
      amount: Yup.string().required("Nominal harus diisi!"),
      description: Yup.string(),
      isActive: Yup.mixed()
        .oneOf([true, false], "Status harus diisi!")
        .required("Status harus diisi!"),
    }),
    onSubmit: (values) => {
      adminUpdateDeductionById(data.id, values)
        .then((response: any) => {
          onCloseClick();
          getData();
          toast.success(
            <div>
              Master Potongan <b>{values?.name}</b> berhasil diperbarui!
            </div>,
          );
          validation.resetForm();
        })
        .catch(() => {});
    },
  });

  const comboType = [
    { value: true, label: "Aktif" },
    { value: false, label: "Tidak Aktif" },
  ];

  useEffect(() => {
    if (!show) {
      validation.resetForm();
    }
  }, [show]);

  return (
    <Modal fade={true} isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalHeader className="bg-light p-3" toggle={onCloseClick}>
        Edit Master Potongan
      </ModalHeader>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <ModalBody>
          <div className="mb-3">
            <Label htmlFor="name" className="form-label">
              Nama
            </Label>
            <Input
              type="text"
              className="form-control"
              id="name"
              name="name"
              placeholder="Nama"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.name || ""}
              invalid={
                validation.touched.name && validation.errors.name ? true : false
              }
            />
            {validation.errors.name && validation.touched.name ? (
              <FormFeedback type="invalid">
                {validation.errors.name}
              </FormFeedback>
            ) : null}
          </div>

          <div className="mb-3">
            <CurrencyInput
              id="amount"
              name="amount"
              label="Nominal"
              value={validation.values.amount}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              required={true}
              invalid={validation.touched.amount && !!validation.errors.amount}
              error={validation.errors.amount}
            />
          </div>

          <div className="mb-3">
            <Label htmlFor="isActive" className="form-label">
              Status
            </Label>
            <Input
              id="isActive"
              name="isActive"
              type="select"
              className="form-select"
              onChange={(e) => {
                const value =
                  e.target.value === "true"
                    ? true
                    : e.target.value === "false"
                      ? false
                      : "";
                validation.setFieldValue("isActive", value);
              }}
              onBlur={validation.handleBlur}
              value={
                validation.values.isActive === ""
                  ? ""
                  : String(validation.values.isActive)
              }
              invalid={
                validation.touched.isActive && !!validation.errors.isActive
              }
            >
              <option value="">Pilih Status</option>
              {comboType.map((item, index) => (
                <option value={String(item.value)} key={index}>
                  {item.label}
                </option>
              ))}
            </Input>
            {validation.touched.isActive && validation.errors.isActive ? (
              <FormFeedback>{validation.errors.isActive}</FormFeedback>
            ) : null}
          </div>

          <div className="mb-3">
            <Label htmlFor="description" className="form-label">
              Deskripsi
            </Label>
            <Input
              type="textarea"
              className="form-control"
              id="description"
              rows={3}
              placeholder="Deskripsi"
              name="description"
              value={validation.values.description || ""}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-soft-danger waves-effect waves-light material-shadow-none btn-sm"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
          >
            Batal
          </button>
          <button
            type="submit"
            className="btn btn-soft-success waves-effect waves-light material-shadow-none btn-sm"
          >
            Simpan
          </button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

UpdateModalDeduction.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  getData: PropTypes.func,
  data: PropTypes.any,
};

export default UpdateModalDeduction;
